<script setup lang="ts">
const route = useRoute()

useHead({
  title: route.meta.title || "XAVER 2025",
  meta: [
    {
      name: "description",
      content: (route.meta.description as string) || "Xaver 2025"
    }
  ]
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
